import { registry } from '@cian/mf-registry/browser';
import { IDesktopFiltersAPI } from 'shared/types/microfrontends';

import { TJsonQuery } from '../../../packages/JsonQuery';

const desktopFiltersApiCall = async <Params, Result = void>(path: string, params?: Params): Promise<Result> => {
  const api = await registry().microfrontendStrict('desktop-filters-micro-frontend').api()?.ensure();

  return api?.call(path, params) as Result;
};

export const getDesktopFiltersMicrofrontendApi = (): IDesktopFiltersAPI => {
  return {
    openAllFiltersModal: () => {
      return desktopFiltersApiCall<void, void>('/v1/open-all-filters-modal');
    },
    openGeoModal: () => {
      return desktopFiltersApiCall<void, void>('/v1/open-geo-modal');
    },
    openDatesPopup: () => {
      return desktopFiltersApiCall<void, void>('/v1/open-dates-popup');
    },
    setJsonQuery: (jsonQuery: TJsonQuery) => {
      return desktopFiltersApiCall<TJsonQuery, void>('/v1/set-json-query', jsonQuery);
    },
    /**
     * Видимость тегов — две ручки без параметров: payload в mf-registry проверяется
     * на truthiness, поэтому `false` до микрофронта не доезжает.
     */
    hideTags: () => {
      return desktopFiltersApiCall<void, void>('/v1/hide-tags');
    },
    showTags: () => {
      return desktopFiltersApiCall<void, void>('/v1/show-tags');
    },
  };
};
